import { css } from "@emotion/react";
import { twitterLink } from "../../../consts";

const Footer: React.FC = () => {
  return (
    <footer
      css={css`
        position: relative;
        background-color: #000;
      `}
    >
      <button
        css={css`
          position: absolute;
          top: -20px;
          left: 50%;
          transform: translateX(-50%);
          width: 280px;
          font-size: 24px;
          font-family: "Bebas Neue", cursive;
          font-weight: 300;
          border-radius: 30px;
          border: 2px solid #e63c3c;
          color: #e63c3c;
          transition: all 0.3s;
          cursor: pointer;
          background-color: #fff;

          &:hover {
            background-color: #e63c3c;
            color: #fff;
          }
          @media screen and (max-width: 630px) {
            top: -26px;
          }
        `}
        onClick={() => window.open(twitterLink, "_blank", "noopenner")}
      >
        <span
          css={css`
            position: relative;
            display: block;
            width: 100%;
            height: 100%;

            &::before,
            &::after {
              content: "▶︎";
              position: absolute;
              font-size: 16px;
              top: 50%;
              transform: translateY(-50%);
            }

            &::before {
              left: 8px;
            }
            &::after {
              content: "◀︎";
              right: 8px;
            }
          `}
        >
          Follow us on Twitter
        </span>
      </button>
      <div
        css={css`
          max-width: 1440px;
          max-height: 430px;
          margin: 0 auto;
        `}
      >
        <img src="/img/footer_logo.png" alt="3600YAKO" />
      </div>
      <div
        css={css`
          color: #fff;
          text-align: center;
          font-size: 14px;
          padding: 16px;
        `}
      >
        ©️ 3600YAKO
      </div>
    </footer>
  );
};

export default Footer;
